import Button from "devextreme-react/button";
import { Template } from "devextreme-react/core/template";
import { SelectBox } from "devextreme-react/select-box";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import { useCompanyContext } from "../../contexts/company";
import { ThemeContext } from "../../theme/theme";
import { RoleEnum, type AppHeaderProps } from "../../types";
import LocaleSelectBox from "../locale-select-box/LocaleSelectBox";
import { ThemeSwitcher } from "../theme-switcher/ThemeSwitcher";
import { UserPanel } from "../user-panel/UserPanel";
import "./AppHeader.scss";

const companyOptions = [
  // { id: 0, name: "Brak" },
  { id: 1, name: "Invenio" },
  { id: 2, name: "Invenio QD" },
  { id: 3, name: "Quality & Human Services" },
  { id: 4, name: "IPSUPPORT" },
];

export const AppHeader = ({
  menuToggleEnabled,
  title,
  toggleMenu,
  className,
}: AppHeaderProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { companyId, setCompanyId } = useCompanyContext();
  const { user } = useAuth();
  const themeContext = useContext(ThemeContext);

  return (
    <header
      className={`header-component ${className} theme-${themeContext?.theme}`}
    >
      <Toolbar className="header-toolbar">
        <Item
          visible={menuToggleEnabled}
          location="before"
          widget="dxButton"
          cssClass="menu-button"
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item location="before">
          <span className="p-2 bg-[#3c8dbc] dark:bg-[#003a80] text-lg text-white font-bold rounded">
            {title}
          </span>
        </Item>
        <Item location="before" locateInMenu="auto">
          {user?.roles?.includes(RoleEnum.AdministratorGlowny.toString()) ? (
            <SelectBox
              dataSource={companyOptions}
              valueExpr="id"
              displayExpr={(item) => (!item ? "" : item.name)}
              value={companyId}
              onValueChanged={(e) => setCompanyId(e.value)}
              width={215}
            />
          ) : null}
        </Item>
        <Item location="after" locateInMenu="auto">
          {user?.roles?.some((role: string) =>
            [
              RoleEnum.AdministratorSpolki.toString(),
              RoleEnum.AdministratorGlowny.toString(),
            ].includes(role),
          ) ? (
            <Button
              text={t("administrationPanel.header")}
              stylingMode="text"
              onClick={() => navigate("/admin-panel", { replace: false })}
              activeStateEnabled={false}
              focusStateEnabled={false}
              hoverStateEnabled={false}
            />
          ) : null}
        </Item>
        <Item
          location="after"
          locateInMenu="auto"
          cssClass={`locale-select-box theme-${themeContext?.theme}`}
        >
          <LocaleSelectBox />
        </Item>
        <Item
          location="after"
          locateInMenu="auto"
          cssClass="swicher-select-box"
        >
          <ThemeSwitcher />
        </Item>
        <Item
          location="after"
          locateInMenu="auto"
          menuItemTemplate="userPanelTemplate"
          cssClass="user-panel-box"
        >
          <UserPanel menuMode="context" />
        </Item>
        <Template name="userPanelTemplate">
          <UserPanel menuMode="list" />
        </Template>
      </Toolbar>
    </header>
  );
};
